import React from 'react';

import {
  ErrorMessage,
  NoStatusesMessage,
  StatusGrid,
  StatusOption,
} from './MobileStatusUpdateDialog.styles';
import { ServiceType } from '../../../../../../@types/service.type';

interface StatusSelectionStepProps {
  currentStatusName: string;
  availableStatuses: ServiceType[];
  error: string | null;
  onSelectStatus: (status: ServiceType) => void;
}

export const StatusSelectionStep: React.FC<StatusSelectionStepProps> = ({
  availableStatuses,
  error,
  onSelectStatus,
}) => {
  if (availableStatuses.length === 0) {
    return <NoStatusesMessage>No available status transitions</NoStatusesMessage>;
  }

  return (
    <>
      {error && <ErrorMessage>{error}</ErrorMessage>}
      <StatusGrid>
        {availableStatuses.map((status) => (
          <StatusOption key={status.code} onClick={() => onSelectStatus(status)}>
            {status.name}
          </StatusOption>
        ))}
      </StatusGrid>
    </>
  );
};
